import { createRoutine } from 'redux-saga-routines';

export const getTeams = createRoutine('GET_TEAMS');
export const getChannelsByTeamId = createRoutine('GET_CHANNELS_BY_TEAM_ID');
